import { addClass, hasClass, removeClass } from '../helpers/generic';

export class ServerMap {
    get openLevels(): number {
        return this._openLevels;
    }

    set openLevels(value: number) {
        this._openLevels = value;
    }

    get selectorId(): string {
        return this._selectorId;
    }

    set selectorId(value: string) {
        this._selectorId = value;
    }

    private _openLevels = 0; // pocet defaultne rozbalenych urovni - vychozi: 0 (vsechny urovne)
    private _selectorId = 'serverMap';

    constructor(openLevels?: number, selectorId?: string) {
        if (openLevels) {
            this.openLevels = openLevels;
        }
        if (selectorId) {
            this.selectorId = selectorId;
        }

        this.initialize();
    }

    initialize = (): void => {
        // inicializace mapy, prvni zobrazeni
        // pokud jsou omezeny rozbalene urovne, pouzavirame je...
        if (this.openLevels) {
            const mapRoot = document.getElementById(this.selectorId);
            if (mapRoot) {
                this.initCloseNodes(mapRoot, this.openLevels);
            }
        }
    };

    initCloseNodes = (node: HTMLElement, level: number): void => {
        const li = node.childNodes;
        for (let i = 0; i < li.length; i++) {
            if (li[i].nodeName != 'LI') {
                continue;
            }

            const ul = li[i].lastChild;
            if (ul && ul.nodeName == 'UL') {
                this.initCloseNodes(ul as HTMLElement, level - 1);
                if (level <= 1) {
                    const trigger = (li[i] as HTMLElement).getElementsByTagName('a')[0];
                    this.changeNodeState(trigger);
                }
            }
        }
    };

    changeNodeState = (node: HTMLLinkElement | HTMLAnchorElement): false => {
        if (!node) {
            return false;
        }

        const li = node.parentNode;
        const trigger = node;

        if (li && li.nodeName == 'LI') {
            const closed = hasClass(li as HTMLLIElement, 'closed');

            if (closed) {
                // otevreme
                removeClass(li as HTMLLIElement, 'closed');
                if (trigger.nodeName == 'A') {
                    removeClass(trigger, 'sm__state--plus');
                    addClass(trigger, 'sm__state--minus');
                }
            } else {
                // zavreme
                addClass(li as HTMLLIElement, 'closed');
                if (trigger.nodeName == 'A') {
                    removeClass(trigger, 'sm__state--minus');
                    addClass(trigger, 'sm__state--plus');
                }
            }
        }

        return false;
    };
}
